import facultyCardOneImg from "../assets/images/coursesPage/retreatFaculty/webp/retreatFacultycard1.webp";
import facultyCardTwoImg from "../assets/images/coursesPage/retreatFaculty/webp/retreatFacultycard2.webp";
export const ashramaFacultyList = [
  {
    image: facultyCardOneImg,
    title: "Dr. Manoj Vats",
  },
  {
    image: facultyCardTwoImg,
    title: "Tejal Shah",
    customClass: "mt-4 mt-md-0",
  },
];

export const ModalList = [
  {
    name: "Dr. Manoj Vats",
    image: facultyCardOneImg,
    title: "Dr. Manoj Vats",
    heading: <>Dr. Vats has 2 MAs in Yoga and Yoga Philosophy and a PhD in Yoga</>,
    description:
      "Trimurti Yoga Master, Dr. Manoj Vats of Chandigarh, has his Bachelors, two Masters’ degree and a PhD in Yoga. He offers asanas as to the most beneficial for any ailment. With 25 years of experience, Dr. Vats has every tool to make your Yoga experience full: Hatha Yoga, Pranayama, Mudras and Bandhs, as well as Naturophathy and Acupressure, which he has shared with VVIP dignitaries like Sports players.", 
    subDescription: "",
    subDescriptionClass: "d-none",
    lefSide: "manojvats_left_side_image",
    rightSide: "manojvats_right_side_image",
  },
  {
    name: "Tejal Shah",
    image: facultyCardTwoImg,
    title: "Tejal Shah",
    heading: <>Joining the Trimurti team is Tejal Shah</>,
    description:
      "Tejal Shah, a multi-faceted karma yogini, has shown brightly in academia, the corporate world, and the sphere of selfless service (teacher, event organizer, lecturer, journalist, media developer, social worker, classical musician and mother), plus the realm of spirituality. Brought to Sahaj Dhyan Yoga at a young age via her family, Tejal now continues volunteer work by leading Sahaj Yoga in tNew Jersey, USA. She credits her life direction and expression to Bapu.",
    subDescription:
      "",
  },
];
